module.exports = __webpack_public_path__ + "img/Surrey.1bd6d14b.jpg";